import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Customer} from './customer.model';
import {CustomerService} from './customer.service';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-customer-datatable',
  templateUrl: './customer-datatable.component.html'
})
export class CustomerDatatableComponent extends DatatableViewComponent<Customer> implements OnInit, OnDestroy {
  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];

  constructor(
    private router: UIRouter,
    private customerService: CustomerService
  ) {
    super(customerService);
  }

  public ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.customerService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.requestParams.addSortParam({key: 'name', value: 'asc'});
    this.fetchData();
  }

  public ngOnDestroy(): void {
    this.customerService.clearRoutePrefix();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.customerService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('customer.edit', { id: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer-datatable.component.ts